var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroPattern(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 1440,
    height: 810,
    viewBox: "0 0 1440 810",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1171276013"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    opacity: 0.87,
    cx: 45,
    cy: 225,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 2",
    opacity: 0.34
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 225,
    r: 45,
    fill: "#295B4A",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 225,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 3",
    opacity: 0.84
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 225,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 225,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    opacity: 0.62,
    cx: 315,
    cy: 225,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 5",
    opacity: 0.1,
    cx: 405,
    cy: 225,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 6",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 495,
    cy: 225,
    r: 45,
    fill: "#295B4A",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495,
    cy: 225,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 7",
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 585,
    cy: 225,
    r: 45,
    fill: "#295B4A",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 585,
    cy: 225,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 8",
    opacity: 0.98,
    cx: 675,
    cy: 225,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 9",
    opacity: 0.52,
    cx: 765,
    cy: 225,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 10",
    opacity: 0.08,
    cx: 855,
    cy: 225,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 11",
    opacity: 0.87
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 945,
    cy: 225,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 945,
    cy: 225,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 12",
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1035,
    cy: 225,
    r: 45,
    fill: "#295B4A",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1035,
    cy: 225,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 13",
    opacity: 0.13,
    cx: 1125,
    cy: 225,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 14",
    opacity: 0.23,
    cx: 1215,
    cy: 225,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 15",
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1305,
    cy: 225,
    r: 45,
    fill: "#295B4A",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1305,
    cy: 225,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 16",
    opacity: 0.34
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1395,
    cy: 225,
    r: 45,
    fill: "#295B4A",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1395,
    cy: 225,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1_2",
    opacity: 0.31,
    cx: 45,
    cy: 315,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2_2",
    opacity: 0.01,
    cx: 135,
    cy: 315,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 3_2",
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 315,
    r: 45,
    fill: "#295B4A",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 315,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 4_2",
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 315,
    cy: 315,
    r: 45,
    fill: "#295B4A",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315,
    cy: 315,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 5_2",
    opacity: 0.98
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 405,
    cy: 315,
    r: 45,
    fill: "#295B4A",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 405,
    cy: 315,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 6_2",
    opacity: 0.82
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 495,
    cy: 315,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495,
    cy: 315,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 7_2",
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 585,
    cy: 315,
    r: 45,
    fill: "#295B4A",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 585,
    cy: 315,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 8_2",
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 675,
    cy: 315,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 675,
    cy: 315,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 9_2",
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 765,
    cy: 315,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 765,
    cy: 315,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 10_2",
    opacity: 0.52,
    cx: 855,
    cy: 315,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 11_2",
    opacity: 0.01,
    cx: 945,
    cy: 315,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 12_2",
    opacity: 0
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1035,
    cy: 315,
    r: 45,
    fill: "#295B4A",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1035,
    cy: 315,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 13_2",
    opacity: 0.03
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1125,
    cy: 315,
    r: 45,
    fill: "#295B4A",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1125,
    cy: 315,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 14_2",
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1215,
    cy: 315,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1215,
    cy: 315,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 15_2",
    opacity: 0.94,
    cx: 1305,
    cy: 315,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 16_2",
    opacity: 0.04
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1395,
    cy: 315,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1395,
    cy: 315,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 1_3",
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 405,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 405,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 33",
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 765,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 765,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 2_3",
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 405,
    r: 45,
    fill: "#295B4A",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 405,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 34",
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 765,
    r: 45,
    fill: "#295B4A",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 765,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3_3",
    opacity: 0.65,
    cx: 225,
    cy: 405,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 35",
    opacity: 0.65,
    cx: 225,
    cy: 765,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 4_3",
    opacity: 0.73
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 315,
    cy: 405,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315,
    cy: 405,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 36",
    opacity: 0.73
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 315,
    cy: 765,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315,
    cy: 765,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 5_3",
    opacity: 0.71,
    cx: 405,
    cy: 405,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 37",
    opacity: 0.71,
    cx: 405,
    cy: 765,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 6_3",
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 495,
    cy: 405,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495,
    cy: 405,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 38",
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 495,
    cy: 765,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495,
    cy: 765,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 7_3",
    opacity: 0.7,
    cx: 585,
    cy: 405,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 39",
    opacity: 0.7,
    cx: 585,
    cy: 765,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 8_3",
    opacity: 0.89,
    cx: 675,
    cy: 405,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 40",
    opacity: 0.89,
    cx: 675,
    cy: 765,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 9_3",
    opacity: 0.54,
    cx: 765,
    cy: 405,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 41",
    opacity: 0.54,
    cx: 765,
    cy: 765,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 10_3",
    opacity: 0.05,
    cx: 855,
    cy: 405,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 42",
    opacity: 0.05,
    cx: 855,
    cy: 765,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 11_3",
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 945,
    cy: 405,
    r: 45,
    fill: "#295B4A",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 945,
    cy: 405,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 43",
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 945,
    cy: 765,
    r: 45,
    fill: "#295B4A",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 945,
    cy: 765,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 12_3",
    opacity: 0.15,
    cx: 1035,
    cy: 405,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 44",
    opacity: 0.15,
    cx: 1035,
    cy: 765,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 13_3",
    opacity: 0.7,
    cx: 1125,
    cy: 405,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 45",
    opacity: 0.7,
    cx: 1125,
    cy: 765,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 14_3",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1215,
    cy: 405,
    r: 45,
    fill: "#295B4A",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1215,
    cy: 405,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 46",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1215,
    cy: 765,
    r: 45,
    fill: "#295B4A",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1215,
    cy: 765,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 15_3",
    opacity: 0.74,
    cx: 1305,
    cy: 405,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 47",
    opacity: 0.74,
    cx: 1305,
    cy: 765,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 16_3",
    opacity: 0.13,
    cx: 1395,
    cy: 405,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48",
    opacity: 0.13,
    cx: 1395,
    cy: 765,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 1_4",
    opacity: 0.94
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 495,
    r: 45,
    fill: "#295B4A",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 495,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 49",
    opacity: 0.94
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    fill: "#295B4A",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 2_4",
    opacity: 0.66
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 495,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 495,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 50",
    opacity: 0.66
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 45,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 45,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 3_4",
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 495,
    r: 45,
    fill: "#295B4A",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 495,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 51",
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 45,
    r: 45,
    fill: "#295B4A",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 45,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 4_4",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 315,
    cy: 495,
    r: 45,
    fill: "#295B4A",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315,
    cy: 495,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 52",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 315,
    cy: 45,
    r: 45,
    fill: "#295B4A",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315,
    cy: 45,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 5_4",
    opacity: 0.46,
    cx: 405,
    cy: 495,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53",
    opacity: 0.46,
    cx: 405,
    cy: 45,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 6_4",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 495,
    cy: 495,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495,
    cy: 495,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 54",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 495,
    cy: 45,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495,
    cy: 45,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 7_4",
    opacity: 0.11
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 585,
    cy: 495,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 585,
    cy: 495,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 55",
    opacity: 0.11
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 585,
    cy: 45,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 585,
    cy: 45,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 8_4",
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 675,
    cy: 495,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 675,
    cy: 495,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 56",
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 675,
    cy: 45,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 675,
    cy: 45,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 9_4",
    opacity: 0.8,
    cx: 765,
    cy: 495,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57",
    opacity: 0.8,
    cx: 765,
    cy: 45,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 10_4",
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 855,
    cy: 495,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 855,
    cy: 495,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 58",
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 855,
    cy: 45,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 855,
    cy: 45,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 11_4",
    opacity: 0.83
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 945,
    cy: 495,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 945,
    cy: 495,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 59",
    opacity: 0.83
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 945,
    cy: 45,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 945,
    cy: 45,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 12_4",
    opacity: 0.98,
    cx: 1035,
    cy: 495,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 60",
    opacity: 0.98,
    cx: 1035,
    cy: 45,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 13_4",
    opacity: 0.35,
    cx: 1125,
    cy: 495,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 61",
    opacity: 0.35,
    cx: 1125,
    cy: 45,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 14_4",
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1215,
    cy: 495,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1215,
    cy: 495,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 62",
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1215,
    cy: 45,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1215,
    cy: 45,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 15_4",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1305,
    cy: 495,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1305,
    cy: 495,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 63",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1305,
    cy: 45,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1305,
    cy: 45,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 16_4",
    opacity: 0.02
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1395,
    cy: 495,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1395,
    cy: 495,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 64",
    opacity: 0.02
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1395,
    cy: 45,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1395,
    cy: 45,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1_5",
    opacity: 0.25,
    cx: 45,
    cy: 585,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2_5",
    opacity: 0.69,
    cx: 135,
    cy: 585,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 3_5",
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 585,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 585,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 4_5",
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 315,
    cy: 585,
    r: 45,
    fill: "#295B4A",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315,
    cy: 585,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 5_5",
    opacity: 0.57,
    cx: 405,
    cy: 585,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 6_5",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 495,
    cy: 585,
    r: 45,
    fill: "#295B4A",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495,
    cy: 585,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 7_5",
    opacity: 0.56,
    cx: 585,
    cy: 585,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 8_5",
    opacity: 0.56,
    cx: 675,
    cy: 585,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 9_5",
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 765,
    cy: 585,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 765,
    cy: 585,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 10_5",
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 855,
    cy: 585,
    r: 45,
    fill: "#295B4A",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 855,
    cy: 585,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 11_5",
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 945,
    cy: 585,
    r: 45,
    fill: "#295B4A",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 945,
    cy: 585,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 12_5",
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1035,
    cy: 585,
    r: 45,
    fill: "#295B4A",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1035,
    cy: 585,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 13_5",
    opacity: 0.96
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1125,
    cy: 585,
    r: 45,
    fill: "#295B4A",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1125,
    cy: 585,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 14_5",
    opacity: 0.91,
    cx: 1215,
    cy: 585,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 15_5",
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1305,
    cy: 585,
    r: 45,
    fill: "#295B4A",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1305,
    cy: 585,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 16_5",
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1395,
    cy: 585,
    r: 45,
    fill: "#295B4A",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1395,
    cy: 585,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 1_6",
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 675,
    r: 45,
    fill: "#295B4A",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 675,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 2_6",
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 675,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 675,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 3_6",
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 675,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 675,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4_6",
    opacity: 0.52,
    cx: 315,
    cy: 675,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 5_6",
    opacity: 0.86,
    cx: 405,
    cy: 675,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 6_6",
    opacity: 0.7,
    cx: 495,
    cy: 675,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 7_6",
    opacity: 0.06,
    cx: 585,
    cy: 675,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 8_6",
    opacity: 0.5,
    cx: 675,
    cy: 675,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 9_6",
    opacity: 0.88,
    cx: 765,
    cy: 675,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 10_6",
    opacity: 0.73
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 855,
    cy: 675,
    r: 45,
    fill: "#295B4A",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 855,
    cy: 675,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 11_6",
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 945,
    cy: 675,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 945,
    cy: 675,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 12_6",
    opacity: 0.42
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1035,
    cy: 675,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1035,
    cy: 675,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 13_6",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1125,
    cy: 675,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1125,
    cy: 675,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 14_6",
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1215,
    cy: 675,
    r: 45,
    fill: "#295B4A",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1215,
    cy: 675,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 15_6",
    opacity: 0.19,
    cx: 1305,
    cy: 675,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 16_6",
    opacity: 0.01,
    cx: 1395,
    cy: 675,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 17",
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 135,
    r: 45,
    fill: "#295B4A",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 135,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 18",
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 135,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 135,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 19",
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 135,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 135,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 20",
    opacity: 0.52,
    cx: 315,
    cy: 135,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 21",
    opacity: 0.86,
    cx: 405,
    cy: 135,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 22",
    opacity: 0.7,
    cx: 495,
    cy: 135,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 23",
    opacity: 0.06,
    cx: 585,
    cy: 135,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 24",
    opacity: 0.5,
    cx: 675,
    cy: 135,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 25",
    opacity: 0.88,
    cx: 765,
    cy: 135,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 26",
    opacity: 0.73
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 855,
    cy: 135,
    r: 45,
    fill: "#295B4A",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 855,
    cy: 135,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 27",
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 945,
    cy: 135,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 945,
    cy: 135,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 28",
    opacity: 0.42
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1035,
    cy: 135,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1035,
    cy: 135,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 29",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1125,
    cy: 135,
    r: 45,
    fill: "#364A43",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1125,
    cy: 135,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 30",
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1215,
    cy: 135,
    r: 45,
    fill: "#295B4A",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1215,
    cy: 135,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 31",
    opacity: 0.19,
    cx: 1305,
    cy: 135,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 32",
    opacity: 0.01,
    cx: 1395,
    cy: 135,
    r: 44.5,
    stroke: "#295B4A",
    strokeOpacity: 0.12
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroPattern);
export default __webpack_public_path__ + "static/media/hero-pattern.0514898b5db4a1eea39baec00dda1af8.svg";
export { ForwardRef as ReactComponent };